module.exports = __webpack_public_path__ + "img/searchplus.e54634c6.png";